export default __webpack_public_path__ + "static/media/loader-3-line.cafce5b1.svg";